module.exports = __webpack_public_path__ + "img/23.e2cffa91.jpg";